import { api } from '../../utils/api';

export const getInfoLand = async (id) => {
  try {
    const response = await api.get(`infoLand/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}
